import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    SAPContactSyncForm,
} from '../ContactSAPContact.types'

const getSAPContactFields = (): DTOCardFormField<keyof SAPContactSyncForm>[] => {
    return [{
        id: 'SAPContactSync',
        title: 'SAP Employee Sync',
        fields: [
            {
                name: 'sapEmployeeId',
                componentName: 'InputSingleline',
                required: true,
                labelKey: 'Contact.sapId',
            },
            {
                name: 'sapEmployeeIdentificationNumber',
                componentName: 'InputSingleline',
                required: true,
                labelKey: 'Contact.sapEmployeeIdentificationNumber',
            },
        ],
    }]
}

export default getSAPContactFields
